import { message, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import {
  deleteCampaign,
  refreshTableCampaigns,
  setCampaignForUpdate,
  setIsCampaignForUpdate,
} from "../../../redux";
import { DataCampaigns } from "../../../redux/@types";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { useCampaigns } from "./useCampaigns";

const { confirm } = Modal;

export const useTableCampaigns = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { tableProps } = useCampaigns();

  const changeCampaignForUpdate = (val: DataCampaigns) => {
    dispatch(setIsCampaignForUpdate(true));
    dispatch(setCampaignForUpdate(val));
    navigate(`/campaigns/${val.id}`);
  };

  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: `Estás seguro de borrar la campaña con el id: ${valId}`,
      icon: <ExclamationCircleOutlined />,
      content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}", si deseas continuar dale click a "Borrar campaña" en caso tal solo oprime en "Cancelar".`,
      okText: "Borrar campaña",
      okType: "danger",
      cancelText: "Cancelar",
      async onOk() {
        await deleteCampaign(valId)
          .then((res) => {
            dispatch(refreshTableCampaigns(true));
            if (res[0]?.name) {
              message.success(
                `Se ha borrado con éxito la campaña con id:${valId}`
              );
            } else if (res) {
              console.log({ res });
              message.error(`${res}`);
            }
            tableProps?.refresh();
          })
          .catch((err) => {
            console.log({ err });
            message.error(err.message);
          });
      },
      onCancel() {},
    });
  };

  return {
    changeCampaignForUpdate,
    showDeleteConfirm,
  };
};
